import React from 'react';
import { Route } from 'react-router-dom';

import DocumentTitle from '../generic/DocumentTitle';
import ShowTargetSupplier from './ShowTargetSupplier';

function Routes() {
  return (
    <DocumentTitle title="Target Supplier">
      <Route path="/target-supplier/:id/show" component={ShowTargetSupplier} />
    </DocumentTitle>
  );
}

export default Routes;
